import { REVIEWS_HEADER, TEXT } from '../../../../constants';
import constants from '../../hoc/withImpressions/constants';
import tracker from '../../../../utils/reports/TrackingService';

const averageScoreImpressionData = (score) => ({
    ...constants.DEFAULT_IMPRESSION,
    page: {
        element: {
            name: 'average_score',
            type: TEXT,
            text: score,
        },
        component: {
            name: REVIEWS_HEADER,
        },
    },
});

const numberOfReviewsImpressionData = (numOfReviews) => ({
    ...constants.DEFAULT_IMPRESSION,
    page: {
        element: {
            name: 'number_of_reviews',
            type: TEXT,
            text: numOfReviews,
        },
        component: {
            name: REVIEWS_HEADER,
        },
    },
});

const reportImpressionEvents = (score, numOfReviews) => {
    if (score) {
        tracker.sendBQEvent(averageScoreImpressionData(score));
    }

    if (numOfReviews) {
        tracker.sendBQEvent(numberOfReviewsImpressionData(numOfReviews));
    }
};

export default reportImpressionEvents;
